import { useState } from "react"
import { isDefined } from "../utils"

export enum FeatureFlagName {
  LABORATORY_PORTAL_ADMIN = "LABORATORY_PORTAL_ADMIN",
  EMAILING_PRESIDENT = "EMAILING_PRESIDENT",
  LAB_SHEET_FAMILY_FLAG = "LAB_SHEET_FAMILY_FLAG",
  EXTRA_LAB_FILTERS = "EXTRA_LAB_FILTERS",
  PHARMACY_PURCHASES_CONNECTOR_MESSAGE = "PHARMACY_PURCHASES_CONNECTOR_MESSAGE",

  /* Feature Flag to delete when V3 is in Prod */
  MY_PHARMACY_V3 = "MY_PHARMACY_V3", // used to switch to v3
  MY_PHARMACY_ACTIVITY = "MY_PHARMACY_ACTIVITY", // used in v2.5
  MY_PHARMACY_BIOSIMILAR = "MY_PHARMACY_BIOSIMILAR", // used in v2.5
  MY_PHARMACY_GENERIC = "MY_PHARMACY_GENERIC", // used in v2.5
  PURCHASES_CHANNEL_V2 = "PURCHASES_CHANNEL_V2", // used in v2.5
  MY_PHARMACY_V25_PERFORMANCE = "MY_PHARMACY_V25_PERFORMANCE", // used in v3
  HEALTH_MISSIONS_GOAL = "HEALTH_MISSIONS_GOAL", // used in v3
  /* End of delete when V3 in Prod */
}

const getFlag = (flagName: FeatureFlagName) => {
  const overrideStr = window.localStorage.getItem(flagName)
  let override: boolean | undefined = undefined
  if (isDefined(overrideStr)) {
    override = overrideStr === "true"
  }

  return override ?? getFlagDefaultValue(flagName)
}

const getFlagDefaultValue = (flagName: FeatureFlagName) =>
  window.FEATURE_FLAGS[flagName] ?? false

export const useFeatureFlag = (flagName: FeatureFlagName) => {
  const [featureFlag, setFeatureFlag] = useState(getFlag(flagName))

  const handleSetFlag = (enabled: boolean) => {
    window.localStorage.setItem(flagName, String(enabled))
    setFeatureFlag(enabled)
  }

  const handleClearFlag = () => {
    window.localStorage.removeItem(flagName)
    setFeatureFlag(getFlagDefaultValue(flagName))
  }

  return {
    get: featureFlag,
    set: (enabled: boolean) => handleSetFlag(enabled),
    clear: handleClearFlag,
  }
}
